import type { ReactNode } from "react";
import { Outlet } from "react-router-dom";
import { CustomerShell } from "../../components/CustomerShell.js";

/** USER persona = a client/hiring org. Renders the redesigned top-navigation CustomerShell. */
export function UsersApp(): ReactNode {
  return (
    <CustomerShell>
      <Outlet />
    </CustomerShell>
  );
}
